import { Col, Row } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { ReactComponent as LogoWhite } from "shared/assets/images/logo-strm.svg";
import { isMobile } from "react-device-detect";

interface ExportCoverPageProps {
  id: string;
  artistName: string;
  lastUpdate?: string;
}
const ExportCoverPage: React.FC<ExportCoverPageProps> = (props) => {
  const { id, artistName, lastUpdate } = props;
  const { t } = useTranslation("radar");

  if (isMobile)
    return (
      <div id={id} className="export-diagnose-cover-page">
        <Row>
          <Col
            xs={12}
            offset={11}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginTop: 16,
            }}
          >
            <span className="cover-date">
              {t("pages.CareerDiagnose.date", {
                date: moment(lastUpdate).format("DD/MM/YYYY"),
              })}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <span
              className="cover-title"
              style={{ marginLeft: 16, display: "block" }}
            >
              {t("pages.CareerDiagnose.coverTitle")}
            </span>
            <span className="cover-title green" style={{ marginLeft: 16 }}>
              {t("pages.CareerDiagnose.coverSubTitle")}
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: 48 }} justify="space-between">
          <Col xs={24}>
            <span className="cover-artist-name">{artistName}</span>
          </Col>
        </Row>
        <div
          className="logo-mobile"
          style={{ marginBottom: 16, marginRight: 16 }}
        >
          <LogoWhite className="logo-white" />
        </div>
      </div>
    );

  return (
    <div id={id} className="export-diagnose-cover-page">
      <Row>
        <span className="cover-title">
          {t("pages.CareerDiagnose.coverTitle")}{" "}
          <span className="green">
            {t("pages.CareerDiagnose.coverSubTitle")}
          </span>
        </span>
      </Row>
      <Row style={{ marginTop: 48 }} justify="space-between">
        <Col xs={12}>
          <span className="cover-artist-name">{artistName?.toUpperCase()}</span>
        </Col>
        <Col
          xs={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <span className="cover-date">
            {t("pages.CareerDiagnose.date", {
              date: moment(lastUpdate).format("DD/MM/YYYY"),
            })}
          </span>
        </Col>
      </Row>
      <LogoWhite className="logo-white" />
    </div>
  );
};

export default ExportCoverPage;
